import styled from 'styled-components'

import ColumnGridPanel from 'components/ColumnGridPanel'

import ThermostatBox from 'pages/Device/SystemStatusPanel/ThermostatBox'
import Damper from 'pages/Device/ZoneStatusPanel/Damper'

import { friendlyName } from 'helpers/formatters'

import { color } from 'styles/colors'

import ZoneStatus from 'types/ZoneStatus'

import React from 'react'

type Props = {
  zone: ZoneStatus
  airFlowPercentage: number
  outdoorTemperature: string
  hasAwairDevice: boolean,
  deviceType: string
}

const Zone = ({ zone, airFlowPercentage, outdoorTemperature, hasAwairDevice = false, deviceType }: Props) => {
  const isLinkSystem = deviceType === 'control_hub'

  return (
    <ColumnGridPanel.Column>
      <S.Header>
        {zone.name || `Null (${zone.id})`}
        {zone.controllingHumidity && !isLinkSystem && <S.DropletIcon aria-label="controlling humidity" className="icon-droplet" />}
      </S.Header>
      <S.Item
        label={<Damper {...zone} fanStatusOn={airFlowPercentage !== null} />}
        value={<S.ThermostatBox
          mode={friendlyName(zone.reqZoneMode)}
          {...zone}
          outdoorTemperature={outdoorTemperature}
          hasAwairDevice={hasAwairDevice}
          displayOperationStatus={isLinkSystem}
               />}
      />
      <S.Item label="Sensor Type" value={friendlyName(zone.sensorType) || '--'} />
      <S.Item label="Zone Mode" value={friendlyName(zone.reqZoneMode) || '--'} />
      {!isLinkSystem && <S.Item label="Voting Zone" value={zone.voting ? 'Yes' : 'No'} />}
    </ColumnGridPanel.Column>
  )
}

export default Zone

const S = {
  Header: styled(ColumnGridPanel.Column.Header)`
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  `,
  DropletIcon: styled.i`
    color: ${color('iconDropletBackground')};
  `,
  Item: styled(ColumnGridPanel.Column.Item)`
    grid-template-columns: 45% 55%;
    padding-right: 5px;
    text-transform: uppercase;
    font-size: 0.9rem;
  `,
  ThermostatBox: styled(ThermostatBox)`
    margin-top: 15px;

    > div:first-of-type {
      max-width: 140px;
      margin: 0px;
    }

    > div:last-of-type {
      display: inline-flex;
      padding-top: 5px;

      > img {
        width: calc(100% - 90px);
      }
    }
  `
}
